import React, { useEffect, useRef, useState } from 'react';
import * as S from './styles';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import { ExpandMore } from '@material-ui/icons';
import NewDepartmentModal from '../NewDepartmentModal';
import SearchIcon from '@mui/icons-material/Search';
import UserItem from '../UserItem';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
const MyDepartments = () => {

	const { allDepartments, departments, isDepartmentsLoading, addDepartment, setDepartments } = useMessage();
	const [ searchQuery, setSearchQuery ] = useState( '' );
	const [ departmentToEdit, setDepartmentToEdit ] = useState( null );
	const [ isNewDepartmentModalOpen, setIsNewDepartmentModalOpen ] = useState( false );
	const [ newDepartmentModalPosition, setNewDepartmentModalPosition ] = useState( { top: 0, left: 0 } );

	const anchorRef = useRef( null );
	const handleOpenNewDepartmentModal = () => {
		if ( anchorRef.current ) {
			const rect = anchorRef.current.getBoundingClientRect();
			setNewDepartmentModalPosition( {
				top  : rect.bottom + window.scrollY,
				left : rect.left + window.scrollX
			} );
		}
		setIsNewDepartmentModalOpen( ( prev ) => !prev );
	};

	const handleCloseNewDepartmentModal = () => {
		setIsNewDepartmentModalOpen( false );
	};

	const handleEditDepartment = ( department ) => {
		setDepartmentToEdit( department );
		setIsNewDepartmentModalOpen( true );
		setNewDepartmentModalPosition( {
			top  : department.top + window.scrollY,
			left : department.left + window.scrollX
		} );
	};


	useEffect( () => {
		const filteredDepartments = allDepartments
			.filter( department => department.name.toLowerCase().includes( searchQuery.toLowerCase() ) );
		setDepartments( filteredDepartments );
	}, [ searchQuery, allDepartments, setDepartments ] );


	return (
		<S.Container>
			{isNewDepartmentModalOpen && <NewDepartmentModal
				onClose={handleCloseNewDepartmentModal}
				position={newDepartmentModalPosition}
				modalRef={anchorRef}
				addDepartment={addDepartment}
				departmentToEdit={departmentToEdit}
				handleSetDepartmentToEdit={setDepartmentToEdit}
			/>}
			<S.TitleContainer>
				<S.Title>Meus departamentos</S.Title>
				<S.ButtonAddDepartment onClick={handleOpenNewDepartmentModal}>
					<AddCircleOutlineIcon />
				</S.ButtonAddDepartment>
			</S.TitleContainer>
			<S.SearchContainer>
				<SearchIcon style={{
					position  : 'absolute',
					left      : '12px',
					top       : '50%',
					transform : 'translateY(-50%)',
					color     : '#aebac1'
				}} />
				<S.SearchInput
					type="text"
					placeholder="Pesquisar departamento"
					value={searchQuery}
					onChange={( e ) => setSearchQuery( e.target.value )}
				/>
			</S.SearchContainer>

			{isDepartmentsLoading ? ( <S.LoadingMessageContainer>
				<S.LoadingMessage>Carregando departamentos...</S.LoadingMessage>
			</S.LoadingMessageContainer> ) :
				( <S.DepartmentList>

					{departments.map( ( department ) => (
						<S.StyledAccordion key={department.id}>
							<AccordionSummary expandIcon={<ExpandMore />} style={{ width: '100%' }}>
								<S.DepartmentItemContainer>
									<S.DepartmentItemContent>
										<S.DepartmentItemTitle>Departamento {department.name}</S.DepartmentItemTitle>
										<S.DepartmentItemSubtitle>Usuários</S.DepartmentItemSubtitle>
									</S.DepartmentItemContent>
									<S.DepartmentItemButton onClick={() => handleEditDepartment( department )}>Editar</S.DepartmentItemButton>
								</S.DepartmentItemContainer>
							</AccordionSummary>
							<AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
								{ department.users.length > 0 ? department.users.map( ( user ) => (
									<UserItem key={user.id} name={user.name} profileType={user.profileTypeName} showProfileType={true} />
								) ): (
									<S.UserItemContainer>
										<S.UserItemText>Nenhum usuário vinculado</S.UserItemText>
									</S.UserItemContainer>
								) }
							</AccordionDetails>
						</S.StyledAccordion>
					) )}
				</S.DepartmentList> )}
		</S.Container>
	);
};


export { MyDepartments };
